export default __webpack_public_path__ + "static/media/graignes9.175b9b2a.jpg";